import { render, staticRenderFns } from "./FooterAuth.vue?vue&type=template&id=e08eeef0"
import script from "./FooterAuth.vue?vue&type=script&lang=js"
export * from "./FooterAuth.vue?vue&type=script&lang=js"
import style0 from "./FooterAuth.vue?vue&type=style&index=0&id=e08eeef0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e08eeef0')) {
      api.createRecord('e08eeef0', component.options)
    } else {
      api.reload('e08eeef0', component.options)
    }
    module.hot.accept("./FooterAuth.vue?vue&type=template&id=e08eeef0", function () {
      api.rerender('e08eeef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/FooterAuth.vue"
export default component.exports